
(() => {
  const GALLERY_SELECTOR = "media-gallery";
  const SLIDE_SELECTOR = "slideshow-slide";
  const THUMBNAILS_SELECTOR = ".slideshow-controls__thumbnails";
  const THUMBNAIL_SELECTOR = ".slideshow-controls__thumbnail";
  const COLOR_FIELDSET_SELECTOR = ".variant-option--buttons";

  let filterTimer = null;
  let observer = null;
  let lastColor = "";

  function getSelectedColor() {
    const fieldsets = document.querySelectorAll(COLOR_FIELDSET_SELECTOR);

    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector("legend");

      if (legend?.textContent.trim().toLowerCase() !== "color") {
        continue;
      }

      const selected = fieldset.querySelector(
        'input[type="radio"]:checked'
      );

      return selected?.value.trim().toLowerCase() || "";
    }

    return "";
  }

  function matchesColor(element, color) {
    const image = element.querySelector("img");
    const alt = (image?.alt || "").trim().toLowerCase();

    return alt.includes(color);
  }

  function filterGallery() {
    const color = getSelectedColor();

    if (!color) return;

    const colorChanged = color !== lastColor;

    document.querySelectorAll(GALLERY_SELECTOR).forEach((gallery) => {

      // FILTER BIG / MAIN SLIDER IMAGES
      const slides = gallery.querySelectorAll(SLIDE_SELECTOR);

      slides.forEach((slide) => {
        slide.hidden = !matchesColor(slide, color);
      });

      // FILTER DESKTOP AND MOBILE THUMBNAILS
      gallery.querySelectorAll(THUMBNAILS_SELECTOR).forEach((container) => {
        const buttons = container.querySelectorAll(THUMBNAIL_SELECTOR);

        buttons.forEach((button) => {
          button.hidden = !matchesColor(button, color);
        });

        container.dataset.colorFilterReady = "true";
      });

      // SELECT FIRST MATCHING IMAGE AFTER COLOR CHANGE
      if (colorChanged) {
        const thumbnails = gallery.querySelectorAll(
          `${THUMBNAILS_SELECTOR} ${THUMBNAIL_SELECTOR}`
        );

        const firstMatchingThumbnail = Array.from(thumbnails).find(
          (button) => matchesColor(button, color)
        );

        if (firstMatchingThumbnail) {
          firstMatchingThumbnail.click();
        }
      }
    });

    lastColor = color;
  }

  function scheduleFilter() {
    clearTimeout(filterTimer);
    filterTimer = setTimeout(filterGallery, 100);
  }

  function init() {
    filterGallery();

    document.addEventListener("change", (event) => {
      if (
        event.target.matches(
          `${COLOR_FIELDSET_SELECTOR} input[type="radio"]`
        )
      ) {
        scheduleFilter();
        setTimeout(scheduleFilter, 300);
      }
    });

    observer = new MutationObserver(() => {
      scheduleFilter();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
